export const NOTIFICATION_STATUSES = {
  ALL: 'all',
  NEW: 'new',
  READ: 'read',
};

export const OPERATION_STATUSES = {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
};
